import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
// import "./HeroCarousel.css";

const HeroCarousel = ({ slides }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const navigate = useNavigate();

  const nextSlide = () => {
    setCurrentSlide((prevIndex) => (prevIndex + 1) % slides.length);
  };

  useEffect(() => {
    const intervalId = setInterval(nextSlide, 5000);
    // console.log("inner width: " + window.innerWidth);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="hero-carousel">
      {slides?.map((slide, index) => (
        <div
          key={index}
          className={`hero-slide ${index === currentSlide ? "active" : ""}`}
        >
          <img src={window?.innerWidth <= 500 ?slide?.mbg : slide?.bg} alt="" className="hero-bg" />
          <div className="hero-content">
            <div className="hero-text">
              <img src={slide.textImg} alt="" className="hero-title" />
            </div>
            <div className={`hero-actions ${window?.innerWidth <=500 ? 'd-none' : ""}`}>
              <button onClick={() => navigate(slide?.buttonLink || "#")}>Learn More</button>
            </div>
          </div>
        </div>
      ))}
      <div className="indicator">
        {slides?.map((_, index) => (
          <div
            key={index}
            className={`indicator-dot ${
              index === currentSlide ? "active" : ""
            }`}
            onClick={() => setCurrentSlide(index)}
          />
        ))}
      </div>
      <div
          style={{
            width: "100%",
            display: "flex",
          }}
          className="hero-section-bottom-border"
        >
          <div
            style={{ height: "7px", width: "20%", backgroundColor: "#016A70" }}
          ></div>
          <div
            style={{ height: "7px", width: "20%", backgroundColor: "#9BEC00" }}
          ></div>
          <div
            style={{ height: "7px", width: "20%", backgroundColor: "#D2DE32" }}
          ></div>
          <div
            style={{ height: "7px", width: "20%", backgroundColor: "#A2C579" }}
          ></div>
          <div
            style={{ height: "7px", width: "20%", backgroundColor: "#50B498" }}
          ></div>
        </div>
    </div>
  );
};

export default HeroCarousel;
